export default class IntegrationErrorLog {
    id: number;
    message: string;
    stackTrace: string;
    date: Date;

    constructor(data?: Partial<IntegrationErrorLog>) {
        if (data) Object.assign(this, data);

        this.date = this.date?.toDate();
    }
}